export const getNumberFromString = (property: any, defaultValue: number) => {
  let number = parseInt(property, 10);
  if (isNaN(number)) {
    number = defaultValue;
  }
  return number;
};
